export default "__VITE_ASSET__u1_TnM25__"